// An enum member cannot have a numeric name
// An enum value can be a string or a number
export const enumToObject = <T extends {}>(enumObject: T) => {
	return Object.entries(enumObject).reduce((accum, [key, value]) => {
		if (!isNaN(parseInt(key))) return accum;
		return {
			...accum,
			[key]: value,
		};
	}, {} as T);
};
